<template>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else class="group-membership">
    <div class="group-list-column">
      <h6 class="component-desc">Available Groups</h6>
      <DxList
        class="dx-card group-list"
        :data-source="groups"
        key-expr="groupId"
        display-expr="groupName"
        height="50vh"
        :page-size="1000"
        pageLoadMode="scrollBottom"
        no-data-text="No groups available"
        :search-enabled="true"
        search-expr="groupName"
        search-mode="contains"
        :item-dragging="availableDragging"
      />
    </div>
    <div class="group-list-column">
      <h6 class="component-desc">Member Groups</h6>
      <DxList
        class="dx-card group-list"
        :data-source="memberGroups"
        key-expr="groupId"
        display-expr="groupName"
        height="50vh"
        no-data-text="User is not a member of any groups"
        :allow-item-deleting="true"
        item-delete-mode="static"
        :item-dragging="memberDragging"
      />
    </div>
  </div>
</template>

<script>

import DxList from "devextreme-vue/list";

export default {
  components: {
    DxList,
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      loading: true,
      memberGroups: [],
    };
  },
  computed: {
    isNewRec(){
      return (this.currentRecordId==0)
    },
    currentRecordId() {
      return this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1);
    },
    user() {
      return this.$store.getters["users/getUser"];
    },
    groups() {
      return this.$store.getters["groups/getGroups"];
    },
    userGroups() {
      return this.$store.getters["users/getUserGroups"];
    },
    availableDragging() {
      return {
        group: "userGroups",
        handle: "",
        onDragStart: this.onDragStart,
      };
    },
    memberDragging() {
      return {
        group: "userGroups",
        onAdd: this.onAddMember,
      };
    },
  },
  methods: {
    onDragStart(e){
      const items = e.component.getDataSource().items();
      e.itemData = items[e.fromIndex];
    },
    onAddMember(e){
      const group = e.itemData;
      if (group && this.memberGroups.findIndex((g) => g.groupId == group.groupId) < 0)
      {
        this.memberGroups = [...this.memberGroups, group];
      }
    },

    saveGroupMembership(){
      const memberIds = this.memberGroups.map((g) => g.groupId);

      //add a user group for any membership that didn't previously exist
      memberIds.forEach((groupId) => {
        if (this.userGroups.findIndex((data) => data.groupId == groupId) < 0)
        {
          this.$store.dispatch("users/addUserGroup", { userGroupId: 0, groupId: groupId, userId: this.currentRecordId });
        }
      });

      //remove any existing user group that is no longer in the member list
      this.userGroups.forEach((ug) => {
        if (!memberIds.includes(ug.groupId))
        {
          this.$store.dispatch("users/deleteUserGroup", { userGroupId: ug.userGroupId });
        }
      });
    },

    setListMembership(){
      const memberIds = this.userGroups.map((ug) => ug.groupId);
      this.memberGroups = this.groups.filter((g) => memberIds.includes(g.groupId));
    },

    refreshData(){
      this.loadPageData();
    },

    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        await this.$store.dispatch("users/loadUser", { id: this.currentRecordId });
        await this.$store.dispatch("groups/loadGroups");
        await this.$store.dispatch("users/loadUserGroups", { id: this.currentRecordId });
        this.setListMembership();
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.group-membership{
  display: flex;
  gap: 20px;
}
.group-list-column{
  flex: 1 1 50%;
  min-width: 0;
  
}
.component-desc{
  font-weight: lighter;
}
.group-list{
  overflow: auto;
  overflow: hidden;
}
</style>
